module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.3065/img/diamond-tier-icon-bordered.svg"